module.exports = __webpack_public_path__ + "img/report_info_date.8711b968.png";